export default "__VITE_ASSET__BXj$p5gM__"